module.exports = __webpack_public_path__ + "static/img/ali-yahya-y_0o9DeorYQ-unsplash_thumb.85d34e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/ali-yahya-y_0o9DeorYQ-unsplash_thumb.png
// module id = Ie7I
// module chunks = 4